import { useMelwaysInfo } from '@seek/melways-react';
import { ProfileVisibilityField } from '@seek/profile-edit-ui';
import { useTranslations } from '@vocab/react';
import { Stack, Text } from 'braid-design-system';
import type { FormEvent } from 'react';

import { LoadingItem } from 'src/components/LoadingItem/LoadingItem';
import { useAnalytics } from 'src/contexts/AnalyticsContext';
import {
  useGetProfileVisibility,
  useUpdateProfileVisibility,
} from 'src/modules/graphql/visibility/legacy-data';
import { useTypedSelector } from 'src/reducers';
import type { VisibilityLevel } from 'src/types/graphql';
import { useGetLocale } from 'src/utils/useGetLocale/useGetLocale';

import translations from './.vocab';

export const LegacyEditProfileVisibilitySettings = () => {
  const { t } = useTranslations(translations);
  const { profileVisibilityLevel, loading, error } = useGetProfileVisibility();
  const { updateProfileVisibility } = useUpdateProfileVisibility();
  const { language } = useMelwaysInfo();
  const { trackProfileVisibilityUpdated } = useAnalytics();
  const zone = useTypedSelector((state) => state.page.pageAnalytics.zone);
  const locale = useGetLocale();

  const onChangeFn = ({
    currentTarget: { value },
  }: FormEvent<HTMLInputElement>) => {
    updateProfileVisibility({
      variables: {
        input: {
          level: value as VisibilityLevel,
        },
        languageCode: language,
        locale,
      },
    });

    trackProfileVisibilityUpdated(value.toLowerCase());
  };

  return loading || error ? (
    <Stack space="large">
      <LoadingItem size="standard" width="small" />
      <LoadingItem size="standard" width="large" />
      <LoadingItem size="standard" width="large" />
      <LoadingItem size="standard" width="large" />
    </Stack>
  ) : (
    <Stack space="small">
      <Text weight="strong">{t('Set visibility')}</Text>
      <ProfileVisibilityField
        id="option"
        onChange={onChangeFn}
        value={profileVisibilityLevel || ''}
        zone={zone}
      />
    </Stack>
  );
};
